<template>
    
    <div class="wrap">
        <rotate-detect></rotate-detect><!--  template   -->
        
        <div class="topbar"></div>
        <div class="rightbar"></div>
        <div class="content">
            <nav-bar :nav="showNav"></nav-bar><!--  template   -->
            <section class="artistpage">
              <div class="block"><svg class="svg100" ratio="0.25" fill="#ffffff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1920 480"><title>blockwhite</title><polygon points="1920 0 0 480 0 0 1920 0" /></svg></div>
              <div class="main">
                <div class="bookmark"><img src="../asset/svg/bookmark/v/artist.svg" alt="多寶創作人"></div>
                <div class="max1000"><a href="/#/?from_artist" class="arrow_back" onclick="gaclick('btn_artist_back')">
                    <svg class="arrowtop" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 33.86 18.28"><title>top</title><path d="M33.38,15.63,16,.39a1.57,1.57,0,0,0-2.58,1.15Q7.08,8.78.42,15.73c-1.33,1.38.77,3.49,2.1,2.1Q9.12,11,15.37,3.8l15.9,13.94C32.71,19,34.82,16.9,33.38,15.63Z" /></svg>
                    <svg class="arrowbg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.86 93.28"><title>btn</title><path d="M0,48.67C-.06,29,12.8,9.5,31,1.79c12.47-5.27,33.3,1.68,39.81,13.45C73.66,20.35,78,24,82.3,27.59c3,2.52,4.79,5.39,4.3,9.48-.39,3.29,1,6.16,2.46,9a15.11,15.11,0,0,1,.18,14c-12.18,25.24-30,34.78-54.36,33a16,16,0,0,1-8.06-2.36C11.93,80.51,0,68.37,0,48.67Z" /></svg></a>
                  <h2 class="artistdescription wow1 fadeInUp"><img src="../img/artist/artistpage3.svg" alt="無敵萬能車"></h2>
                  <div class="artistinfo">
                    <div class="artistpic wow1 fadeInUp"><img src="../img/artist/artist03.jpg"></div>
                    <div class="txtcontent strip">
                      <h2 class="wow2 fadeInUp"><span>創作人/</span><b>高健騰</b></h2>
                      <p class="wow3 fadeInUp">「當初畫自己理想的無敵萬能車時，只是想到什麼就把它給畫上去，在新事物的影響下，各自創造天下無敵萬能車、所向無敵萬能車、世界無敵萬能車和宇宙無敵萬能車。功能更加多樣化外，構造方面也精密許多，畫無敵萬能車不但能表現我的思想、生命、創新外，還是能釋放自己負面情緒的場所，每一輛「無敵萬能車」都是我接觸新事物和新想法的獨特證明，更專屬於自己的標誌。」<br>------健騰的創作自述</p>
                    </div>
                  </div>
                  <div class="worklist">
                    <ul>
                      <li>
                        <div class="featurepic wow1 fadeInUp"><img src="../img/artist/work03_1.jpg" alt=""></div>
                        <h3 class="wow2 fadeInUp">天下無敵萬能車</h3>
                        <p class="wow3 fadeInUp">78.6(L) x 54.5(M)cm (2K) 麥克筆 2004.</p>
                      </li>
                      <li>
                        <div class="featurepic wow1 fadeInUp"><img src="../img/artist/work03_2.jpg" alt=""></div>
                        <h3 class="wow2 fadeInUp">千年古物</h3>
                        <p class="wow3 fadeInUp">78.6(L) x 54.5(M)cm (2K) 麥克筆 2004.</p>
                      </li>
                      <li>
                        <div class="featurepic wow1 fadeInUp"><img src="../img/artist/work03_3.jpg" alt=""></div>
                        <h3 class="wow2 fadeInUp">黑暗伊加洛斯</h3>
                        <p class="wow3 fadeInUp">78.6(L) x 54.5(M)cm (2K) 麥克筆 2007.</p>
                      </li>
                    </ul>
                  </div><a href="javascript:void(0)" class="btn wow4 fadeInUp" onclick="trackWaitJump('btn_moreworks_gaojianteng','https://taiwancurio.wordpress.com/category/%E9%AB%98%E5%81%A5%E9%A8%B0/')">
                    <!--blogicon-->
                    <div class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41.24 35.64"><title>read</title><path d="M36.64,0H23.83a4.64,4.64,0,0,0-3.2,1.33A4.64,4.64,0,0,0,17.42,0H4.6A4.67,4.67,0,0,0,0,4.6V27.83a4.67,4.67,0,0,0,4.6,4.6H17.42a1.78,1.78,0,0,1,1.8,1.8,1.4,1.4,0,0,0,1.4,1.4,1,1,0,0,0,.41-.07,1.28,1.28,0,0,0,.82-.63,1.25,1.25,0,0,0,.17-.7,1.78,1.78,0,0,1,1.8-1.8H36.64a4.67,4.67,0,0,0,4.6-4.6V4.6A4.67,4.67,0,0,0,36.64,0ZM22,4.6a1.78,1.78,0,0,1,1.8-1.8H36.64a1.78,1.78,0,0,1,1.8,1.8V27.83a1.78,1.78,0,0,1-1.8,1.8H23.83A4.18,4.18,0,0,0,22,30Zm-2.8,0V30a4.18,4.18,0,0,0-1.8-.41H4.6a1.78,1.78,0,0,1-1.8-1.8V4.6A1.78,1.78,0,0,1,4.6,2.8H17.42A1.78,1.78,0,0,1,19.22,4.6Z" /></svg></div><span>更多健騰的事</span></a>
                </div>
              </div>
              <div class="switchbtn"><router-link to="/artist2" class="btn artist2">
                  <p> <span>創作人/</span><b>林佳瑄</b></p></router-link><router-link to="/artist4" class="btn artist4">
                  <p><span>創作人/</span><b>莊博為</b></p></router-link></div>
            </section>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import ScrollReveal from 'scrollreveal'
    
    import navBar from './common/Nav.vue'
    import rotateDetect from './common/RotateDetect.vue'

    export default {
      components: {
          navBar,
          rotateDetect
      },
      data: function() {
            return {
               showNav:false
            }
      },
      created: function() {
            //Scrolls to top when view is displayed
            window.scrollTo(0, 0);
      },
      mounted: function(){
          window.sr = ScrollReveal({ reset: true });
            // Customizing a reveal set
          var vv = function(ele,dur,del){
              sr.reveal(ele, { 
                  origin: 'bottom',
                  duration: dur,
                  delay: del,
                  opacity: 0,
                  scale: 1,
                  easing: 'cubic-bezier(0.42, 0, 0.58, 1)',
                  // mobile: true
              });
          }
          vv('.wow1',500,0);
          vv('.wow2',500,200);
          vv('.wow3',500,400);
          vv('.wow4',500,600);

          $('.main').animate({opacity:1});
          $('.logo').on('click',function(){
              window.location="/#/?from_artist";
              gaclick('btn_logo');
          });
          gapage('pv_gaojianteng');
          
      }

    }
</script>

<style>
    @import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.5.2/animate.min.css';
</style>


// WEBPACK FOOTER //
// Artist3.vue?2ea95d34